module.exports = __webpack_public_path__ + "img/1563273528.5f1f3669.jpg";